import Vue from 'vue'
import { MutationTree } from 'vuex'

import { Option } from '@/models'

import { makeRelationalObject } from '../../models'
import { MenuState, OptionGroupOptions } from '../state'

export const ADD_OPTION = 'ADD_OPTION'
export const ADD_OPTION_GROUP_OPTIONS = 'ADD_OPTION_GROUP_OPTIONS'
export const CLEAR_OPTION_GROUPS_OPTIONS = 'CLEAR_OPTION_GROUPS_OPTIONS'
export const INCREMENT_OPTION_GROUP_OPTIONS_QUERY_INDEX = 'INCREMENT_OPTION_GROUP_OPTIONS_QUERY_INDEX'
export const LOADED_ALL_OPTION_GROUP_OPTIONS = 'LOADED_ALL_OPTION_GROUP_OPTIONS'
export const REMOVE_OPTION_GROUP_OPTIONS = 'REMOVE_OPTION_GROUP_OPTIONS'
export const RESET_LOADED_ALL_OPTION_GROUP_OPTIONS = 'RESET_LOADED_ALL_OPTION_GROUP_OPTIONS'
export const RESET_OPTION_GROUP_OPTIONS_QUERY_INDEX = 'RESET_OPTION_GROUP_OPTIONS_QUERY_INDEX'
export const UPDATE_OPTION_GROUP_OPTIONS = 'UPDATE_OPTION_GROUP_OPTIONS'
export const UPDATE_OPTION_GROUP_OPTIONS_TOTAL = 'UPDATE_OPTION_GROUP_OPTIONS_TOTAL'
export const UPDATE_OPTIONS = 'UPDATE_OPTIONS'

const mutations: MutationTree<MenuState> = {
  [ADD_OPTION] (state, option: Option) {
    state.options.elements.push(option)
  },

  [ADD_OPTION_GROUP_OPTIONS] (state, optionGroupId: number) {
    const optionGroupOptions: OptionGroupOptions = {
      ...makeRelationalObject(),
      query: {}
    }

    Vue.set(state.optionGroups.options, optionGroupId, optionGroupOptions)
  },

  [CLEAR_OPTION_GROUPS_OPTIONS] (state) {
    state.optionGroups.options = {}
  },

  [INCREMENT_OPTION_GROUP_OPTIONS_QUERY_INDEX] (
    state,
    { optionGroupId, offset }: { optionGroupId: number; offset: number }
  ) {
    const optionGroupOptions = state.optionGroups.options[optionGroupId]

    if (optionGroupOptions === undefined) {
      throw new Error(`Options relation for OptionGroup "${optionGroupId}" was not found`)
    }

    optionGroupOptions.query.index = (optionGroupOptions.query.index ?? 0) + offset
  },

  [LOADED_ALL_OPTION_GROUP_OPTIONS] (state, optionGroupId: number) {
    const optionGroupOptions = state.optionGroups.options[optionGroupId]

    if (optionGroupOptions === undefined) {
      throw new Error(`Options relation for OptionGroup "${optionGroupId}" was not found`)
    }

    optionGroupOptions.didLoadAll = true
  },

  [REMOVE_OPTION_GROUP_OPTIONS] (state, optionGroupId: number) {
    Vue.delete(state.optionGroups.options, optionGroupId)
  },

  [RESET_LOADED_ALL_OPTION_GROUP_OPTIONS] (state, optionGroupId: number) {
    const optionGroupOptions = state.optionGroups.options[optionGroupId]

    if (optionGroupOptions === undefined) {
      throw new Error(`Options relation for OptionGroup "${optionGroupId}" was not found`)
    }

    optionGroupOptions.didLoadAll = false
  },

  [RESET_OPTION_GROUP_OPTIONS_QUERY_INDEX] (state, optionGroupId: number) {
    const optionGroupOptions = state.optionGroups.options[optionGroupId]

    if (optionGroupOptions === undefined) {
      throw new Error(`Options relation for OptionGroup "${optionGroupId}" was not found`)
    }

    optionGroupOptions.query.index = 0
  },

  [UPDATE_OPTION_GROUP_OPTIONS] (
    state,
    { optionGroupId, options }: { optionGroupId: number; options: number[] }
  ) {
    const optionGroupOptions = state.optionGroups.options[optionGroupId]

    if (optionGroupOptions === undefined) {
      throw new Error(`Options relation for OptionGroup "${optionGroupId}" was not found`)
    }

    optionGroupOptions.ids = new Set(options)
  },

  [UPDATE_OPTION_GROUP_OPTIONS_TOTAL] (
    state,
    { optionGroupId, total }: { optionGroupId: number; total: number }
  ) {
    const optionGroupOptions = state.optionGroups.options[optionGroupId]

    if (optionGroupOptions === undefined) {
      throw new Error(`Options relation for OptionGroup "${optionGroupId}" was not found`)
    }

    optionGroupOptions.total = total
  },

  [UPDATE_OPTIONS] (state, options: Option[]) {
    state.options.elements = options
  }
}

export default mutations
